export type EventData = Record<string, string | number | boolean>;

declare global {
    interface Window {
        umami?: { track: (event: string, data?: EventData) => void };
    }
}

// Umami is only loaded after consent, so without it this does nothing.
export const track = (event: string, data?: EventData) => window.umami?.track(event, data);
